import {DomainObject, oneOf} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import GroupBenefitCoverage from './GroupBenefitCoverage';
import BenefitDivision from './BenefitDivision';
import {AttachedLink} from 'main/stores/links';
import {AttachedDocument} from 'main/stores/documents';
import _ from 'lodash';

class BenefitClass extends DomainObject {
  name;
  defaultProbation;
  probationTimePeriod;
  fullName;
  divisionName;
  carrierName;
  groupBenefitCoverages;
  benefitDivision;

  attachedLinks;
  attachedDocuments;

  _relations = {
    benefitDivision: BenefitDivision,
    groupBenefitCoverages: [GroupBenefitCoverage],
    attachedLinks: [AttachedLink],
    attachedDocuments: [AttachedDocument],
    probationTimePeriod: oneOf(['months', 'days'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      defaultProbation: observable,
      probationTimePeriod: observable,
      fullName: observable,
      divisionName: observable,
      carrierName: observable,
      groupBenefitCoverages: observable,
      benefitDivision: observable,
      attachedLinks: observable,
      attachedDocuments: observable,
      sortedGroupBenefitCoverages: computed
    });

    this.merge(other);
  }

  get sortedGroupBenefitCoverages() {
    return _.sortBy(
      this.groupBenefitCoverages, [
        (coverage) => coverage.coverageType !== 'extended_health_care',
        (coverage) => coverage.coverageType !== 'dental',
        (coverage) => coverage.coverageType
      ]
    );
  }
}

export default BenefitClass;
